import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';
import { GlobalErrorHandler } from './error-handler';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService, 
        private router: Router,
        // private _errorHandler: GlobalErrorHandler        
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        let url: string = state.url;
        return  this.authService.subscribeToLoginService()
                .map((userInfo) => {                   
                        if(userInfo != null && userInfo.userId != null)
                        {
                                return true;
                        }
                        this.router.navigate(['/401']);
                        return false;

                    },
                    err => {
                        console.log('error: ' + err)
                        return false;
                    });
    }

   
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/auth-guard.service.ts